import { useState } from 'react'
import cl from 'classnames'
import styles from './image-preview.module.scss'
import { StyleProps } from '@touche-lts/panel-ui/dist'
import {
  PictureProps
} from '@touche-lts/panel-ui/dist/components/shared/picture'
import { GalleryImage } from '@touche-lts/panel-ui/dist'
import { Button } from '@touche-lts/panel-ui/dist/components/shared/button'
import { IconMenuDots } from '@touche-lts/panel-ui/dist/components/icons/icon-menu-dots'
import { IconDeleteCircle } from '@touche-lts/panel-ui/dist/components/icons/icon-delete-circle'
import { IconEditCrop } from '@touche-lts/panel-ui/dist/components/icons/icon-edit-crop'
import AvatarEditor from 'react-avatar-editor'
import { useRootStore } from "mobx-stores/store-provider"
import { observer } from 'mobx-react-lite'

export interface ImagePreviewProps extends StyleProps, Partial<GalleryImage> {
  alt?: string
  removeItem?: () => void
  openImageEditor?: () => void
  saveOriginalDimensions?: PictureProps['saveOriginalDimensions']
  removeCropping: PictureProps['removeCropping']
  width?: number
  height?: number
  isSquare?: boolean
}

const ImagePreviewComponent = (props: ImagePreviewProps) => {
  const {
    className,
    style,
    // src,
    alt,
    removeItem,
    openImageEditor,
    saveOriginalDimensions,
    removeCropping,
    width,
    height,
    isSquare,
    ...img
  } = props,
  {
    imagesStore: {
        squareImageLink,
        backgroundImageLink,
        getPositionSquare,
        getPositionBackground,
        getScaleSquare,
        getScaleBackground
    }
  } = useRootStore();

  const [expandOptions, setExpandOptions] = useState<boolean>(false)

  return (
    <div className={cl(styles.container, className)} style={{width: width, height: height}}>
        <AvatarEditor 
            width={width} 
            height={height} 
            border={0}
            scale={isSquare ? getScaleSquare : getScaleBackground}
            position={isSquare ? getPositionSquare : getPositionBackground}
            image={isSquare ? squareImageLink : backgroundImageLink} 
            style={{pointerEvents: 'none'}}
        />
      <div
        className={cl(styles.optionsContainer, {
          [styles.optionsContainerExpanded]: expandOptions
        })}
        style={{width: width, height: height}}
        onMouseEnter={() => setExpandOptions(true)}
        onMouseLeave={() => setExpandOptions(false)}
      >
        {/* <IconMenuDots className={styles.triggerOptionsIcon} /> */}
        <div
          className={cl(styles.iconsContainer, {
            [styles.iconsContainerCollapsed]: !expandOptions
          })}
        >
          <Button
            preset='icon'
            title='Remove image'
            className={styles.iconButton}
            onClick={removeItem}
          >
            <IconDeleteCircle width={20} />
          </Button>
            <Button
              preset='icon'
              title='Crop/position image'
              className={styles.iconButton}
              onClick={openImageEditor}
            >
              <IconEditCrop width={20} />
            </Button>
        </div>
      </div>
    </div>
  )
}

const ImagePreview = observer(ImagePreviewComponent)
export { ImagePreview }
